module.exports = __webpack_public_path__ + "img/horizontal_4_5_7005.88046a4c.png";